import { render, staticRenderFns } from "./LabelContractsSplitsEditPanel.vue?vue&type=template&id=6b88d412"
import script from "./LabelContractsSplitsEditPanel.vue?vue&type=script&lang=js"
export * from "./LabelContractsSplitsEditPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports